import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { CATALOG_SLUG } from '../constants';
import { fetchCatalog, fetchCatalogProducts } from '../api';

const CatalogContext = createContext({
  loading: true,
  catalog: null,
  products: [],
  refresh: () => {}
});

export const CatalogProvider = ({ children }) => {
  const [state, setState] = useState({ loading: true, catalog: null, products: [], error: null });

  const loadCatalog = useCallback(async () => {
    setState(prev => ({ ...prev, loading: true }));
    try {
      const [catalog, products] = await Promise.all([
        fetchCatalog(CATALOG_SLUG),
        fetchCatalogProducts(CATALOG_SLUG)
      ]);
      setState({ loading: false, catalog, products, error: null });
    } catch (error) {
      console.error('Failed to load catalog', error);
      setState(prev => ({ ...prev, loading: false, error }));
    }
  }, []);

  useEffect(() => {
    loadCatalog();
  }, [loadCatalog]);

  const value = useMemo(() => ({
    ...state,
    catalogSlug: CATALOG_SLUG,
    refresh: loadCatalog
  }), [state, loadCatalog]);

  return (
    <CatalogContext.Provider value={value}>
      {children}
    </CatalogContext.Provider>
  );
};

export const useCatalog = () => useContext(CatalogContext);
